import Vue from "vue";
import Vuetify from "vuetify/lib";
import fr from "vuetify/es5/locale/fr";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#0C2251",
        secondary: "#d46b2b",
        accent: "#a5cffd",
        error: "#de2e47",
        info: "#93c5fd",
        success: "#109155",
        warning: "#e86d7e",
        um6p: "#d84a2b",
        firsi: "#35486f",
        ecSecondary: "#0D263C",
        ecPrimary: "#009c7f",
      },
      dark: {
        um6p: "#d84a2b",
        ecSecondary: "#0D263C",
        ecPrimary: "#009c7f",
        primary: "#0C2251",
        secondary: "#d46b2b",
        firsi: "#35486f",
      },
    },
  },
  lang: {
    locales: { fr },
    current: "fr",
  },
});
